var _path, _path2, _g, _g2, _g3, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundCost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1777,
    height: 1264,
    viewBox: "0 0 1777 1264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1728 495.535C1457.23 380.091 1164.07 318.916 864 318.916C564.155 318.916 270.608 380.001 0 495.278V694.085H1728V495.535Z",
    fill: "url(#paint0_radial_170_448)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M853.705 388.978C954.971 407.646 1081.68 456.229 1209.85 530.289C1338.02 604.35 1443.41 689.886 1510.2 768.326C1543.59 807.545 1567.35 845.011 1579.47 878.4C1591.58 911.786 1592.08 941.167 1578.84 964.132C1565.59 987.095 1539.91 1001.35 1504.97 1007.54C1470.02 1013.73 1425.72 1011.87 1375.09 1002.54C1273.82 983.87 1147.11 935.288 1018.94 861.227C890.776 787.167 785.382 701.63 718.596 623.19C685.205 583.972 661.446 546.507 649.328 513.118C637.211 479.732 636.711 450.352 649.958 427.387C663.205 404.423 688.878 390.166 723.825 383.976C758.775 377.784 803.074 379.645 853.705 388.978ZM724 384.96C689.207 391.124 663.866 405.278 650.824 427.887C637.782 450.496 638.204 479.538 650.268 512.777C662.33 546.012 686.009 583.374 719.357 622.542C786.052 700.874 891.349 786.343 1019.44 860.362C1147.54 934.38 1274.14 982.912 1375.27 1001.55C1425.84 1010.88 1470 1012.72 1504.79 1006.56C1539.59 1000.39 1564.93 986.24 1577.97 963.632C1591.01 941.022 1590.59 911.98 1578.53 878.741C1566.46 845.505 1542.79 808.143 1509.44 768.975C1442.74 690.642 1337.45 605.174 1209.35 531.155C1081.25 457.136 954.651 408.603 853.523 389.962C802.957 380.64 758.789 378.798 724 384.96ZM879.742 462.83C924.068 454.268 988.985 464.877 1062.79 492.713L1062.81 492.718L1121.2 518.543L1121.17 518.62C1121.2 518.543 1121.2 518.543 1121.2 518.543L1121.25 518.565L1121.4 518.63C1121.48 518.665 1121.58 518.712 1121.71 518.77C1121.79 518.805 1121.88 518.844 1121.97 518.888C1122.48 519.117 1123.24 519.459 1124.22 519.911C1126.19 520.816 1129.08 522.164 1132.77 523.935C1140.14 527.477 1150.71 532.713 1163.48 539.49C1189.02 553.045 1223.37 572.769 1258.63 597.443C1329.14 646.782 1387.17 701.927 1422.3 752.954C1439.87 778.468 1451.12 802.123 1455.86 822.939C1460.58 843.756 1458.78 861.748 1450.19 875.911C1441.59 890.074 1426.51 899.91 1405.95 905.191C1385.39 910.471 1359.32 911.2 1328.75 907.139C1267.58 899.019 1192.31 872.269 1116.48 831.715C1040.64 791.159 969.218 739.457 915.06 685.913C860.91 632.377 827.552 580.489 821.047 539.589C817.793 519.13 821.362 502.076 831.316 489.063C841.267 476.053 857.576 467.112 879.742 462.83ZM1062.43 493.644C988.684 465.834 923.983 455.302 879.932 463.812C857.921 468.064 841.867 476.915 832.11 489.671C822.361 502.416 818.812 519.174 822.034 539.432C828.488 580.008 861.654 631.706 915.763 685.202C969.845 738.67 1041.19 790.317 1116.95 830.833C1192.72 871.351 1267.87 898.048 1328.88 906.148C1359.38 910.198 1385.3 909.46 1405.7 904.222C1426.09 898.986 1440.91 889.269 1449.33 875.392C1457.75 861.515 1459.57 843.808 1454.88 823.161C1450.19 802.509 1439 778.971 1421.48 753.521C1386.44 702.623 1328.5 647.558 1258.06 598.262C1222.84 573.618 1188.52 553.915 1163.01 540.374C1150.25 533.603 1139.7 528.373 1132.33 524.836C1128.65 523.068 1125.77 521.722 1123.8 520.82C1122.82 520.368 1122.07 520.027 1121.56 519.8C1121.31 519.686 1121.12 519.6 1120.99 519.543L1120.85 519.479L1120.8 519.459L1120.8 519.458C1120.8 519.457 1120.8 519.457 1121 519L1120.8 519.458L1062.43 493.644ZM924.698 533.685C942.643 518.09 973.731 511.603 1013.52 515.077L1013.54 515.079L1013.56 515.083L1013.48 515.575C1013.56 515.083 1013.56 515.083 1013.56 515.083L1013.57 515.083L1013.69 515.104L1014.05 515.167C1014.36 515.223 1014.83 515.306 1015.43 515.414C1016.64 515.63 1018.39 515.948 1020.58 516.353C1024.96 517.165 1031.06 518.327 1037.99 519.734C1051.84 522.546 1068.98 526.336 1082.14 530.243C1148.46 549.931 1183.83 573.607 1238.32 610.088C1242.2 612.688 1246.18 615.352 1250.28 618.084C1256.44 622.198 1264.22 627.631 1270.45 632.033C1273.57 634.235 1276.3 636.179 1278.25 637.573C1278.86 638.009 1279.4 638.391 1279.84 638.71C1280.11 638.902 1280.35 639.071 1280.55 639.215C1280.82 639.408 1281.02 639.557 1281.17 639.658L1281.37 639.802L1281.38 639.809L1281.38 639.811C1281.38 639.811 1281.38 639.812 1281.34 639.866L1281.38 639.812L1281.4 639.828L1281.42 639.846C1316.06 671.032 1339.93 703.106 1349.66 731.541C1354.52 745.761 1355.72 758.721 1353.34 770.003C1350.96 781.288 1344.99 790.882 1335.53 798.366C1316.6 813.327 1284.7 819.094 1244.36 814.908C1204.01 810.721 1157.23 796.786 1110.62 775.077C1064 753.368 1019.91 724.978 984.573 693.918C949.238 662.86 924.425 630.69 913.664 601.949C902.9 573.201 906.731 549.298 924.698 533.685ZM1013.41 516.071C973.728 512.61 942.988 519.115 925.354 534.44C907.803 549.691 903.929 573.098 914.6 601.599C925.281 630.124 949.961 662.165 985.233 693.167C1020.49 724.158 1064.5 752.498 1111.04 774.17C1157.57 795.845 1204.25 809.741 1244.46 813.913C1284.71 818.089 1316.29 812.301 1334.91 797.582C1344.19 790.238 1350.03 780.846 1352.37 769.796C1354.7 758.734 1353.53 745.961 1348.71 731.865C1339.07 703.661 1315.33 671.731 1280.77 640.608L1279.97 640.028C1279.43 639.643 1278.65 639.084 1277.67 638.387C1275.72 636.994 1272.99 635.05 1269.87 632.85C1263.64 628.448 1255.88 623.022 1249.72 618.916C1245.63 616.186 1241.66 613.525 1237.78 610.93C1183.28 574.446 1148.03 550.846 1081.86 531.201C1068.74 527.308 1051.63 523.525 1037.79 520.714C1030.87 519.309 1024.77 518.147 1020.4 517.337C1018.21 516.932 1016.46 516.614 1015.26 516.398C1014.82 516.32 1014.46 516.255 1014.17 516.204L1013.41 516.071Z",
    fill: "url(#paint1_angular_170_448)",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_170_448)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1145,
    cy: 632,
    r: 355,
    fill: "#8B2E2D",
    fillOpacity: 0.75
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_170_448)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1145,
    cy: 632,
    r: 242.714,
    fill: "#CF5E14",
    fillOpacity: 0.75
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_170_448)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1145,
    cy: 632,
    r: 120,
    fill: "#DD7501",
    fillOpacity: 0.75
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.74 892.4C1101.35 878.769 1121.81 877.13 1135.44 888.738C1149.07 900.346 1150.71 920.806 1139.1 934.437C1127.49 948.067 1107.03 949.707 1093.4 938.099C1079.77 926.491 1078.13 906.031 1089.74 892.4Z",
    fill: "url(#paint2_radial_170_448)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.486 742.854C615.263 741.989 616.593 741.917 617.458 742.693L814.468 919.497C815.333 920.273 815.405 921.604 814.629 922.469C813.853 923.334 812.522 923.406 811.657 922.629L614.647 745.825C613.782 745.049 613.71 743.719 614.486 742.854Z",
    fill: "url(#paint3_linear_170_448)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_170_448",
    x: 513,
    y: 0,
    width: 1264,
    height: 1264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.5,
    result: "effect1_foregroundBlur_170_448"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_170_448",
    x: 735.286,
    y: 222.286,
    width: 819.427,
    height: 819.427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 83.5,
    result: "effect1_foregroundBlur_170_448"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_170_448",
    x: 1005,
    y: 492,
    width: 280,
    height: 280,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_170_448"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_170_448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(914.421 946.191) rotate(-90) scale(603.347 2816.76)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.777954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991435,
    stopColor: "#262629"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_170_448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1119.5 642.5) rotate(119.181) scale(132.289 178.15)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458211,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538074,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999001,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_170_448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1112 946.5) rotate(-84.7261) scale(65.2763 58.1367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789417,
    stopColor: "#313F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924165,
    stopColor: "#708688"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_170_448",
    x1: 812.974,
    y1: 921.1,
    x2: 640.488,
    y2: 722.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.190577,
    stopColor: "#BAFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427388,
    stopColor: "#AFD4F9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCost);
export default __webpack_public_path__ + "static/media/backgroundCost.92cd9c0c4850aa8761fad71167b3a874.svg";
export { ForwardRef as ReactComponent };